import axios from 'axios'

export const authClient = axios.create({
  baseURL: process.env.EXPO_PUBLIC_API_URL,
})

export async function authUpgrade() {
  return authClient.post<{ token: string }>(
    `/auth/upgrade`,
    {},
    {
      baseURL: window.location.origin,
    },
  )
}

export async function logout() {
  return authClient.delete(`/users/sign_out`, {
    baseURL: window.location.origin,
  })
}

export async function magicLinkEmail(email: string, returnURL: string) {
  const params = { user: { email, return_to: returnURL } }

  return authClient.post(`/magic_link`, params, {
    baseURL: window.location.origin,
  })
}
